<template>
    <v-combobox
            ref="searchInput"
            auto-select-first
            :menu-props="{ auto: false}"
            flat
            outlined
            clearable
            v-model="model"
            :disabled="loadingCreate"
            :items="items"
            :loading="loading || loadingCreate"
            :search-input.sync="search"
            :error-messages="shouldCreate ? 'Medicamento no encontrado' : (errorMessages || null)"
            :filter="() => true"
            color="primary"
            item-text="title"
            item-value="id"
            :label="label || 'Buscar medicamento'"
            @click:clear="clearSearch"
            return-object
    >
        <template slot="no-data">
            <span class="caption pa-2">Medicamento no encontrado:
            <v-btn
                    :disabled="!shouldCreate"
                    color="primary"
                    rounded small
                    :loading="loadingCreate"
                    depressed
                    @click="createMedicine">crearlo</v-btn>
            </span>
        </template>

        <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-content v-text="data.item.title"></v-list-item-content>
            </template>
        </template>
    </v-combobox>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['value', 'errorMessages', 'label', 'attach'],
        data(){
            return {
                descriptionLimit: 60,
                medicines: [],
                loading: false,
                loadingCreate: false,

                search: '',
                model: null,
            }
        },
        mounted(){
            this.getItems()
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearSearch(){
                var vm = this
                vm.search = ''
                vm.model = null
                vm.$refs.searchInput.blur()
            },
            async createMedicine(){

                var vm =this

                if(vm.search.length < 3){
                    vm.showSnackBar('El texto debe contener al menos 3 caracteres')
                    return
                }

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                 vm.loadingCreate = true
                const response = await ApiUtils.makePost(`providers/${vm.currentProvider.id}/medicine`, {
                    name: vm.search
                })
                 vm.loadingCreate = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando crear el medicamento')
                    vm.$emit('error', json)
                    return
                }

                const json = await response.json()
                vm.medicines.push(json.result.medicine)
                vm.clearSearch()
                vm.$nextTick(async function(){

                    const createdModel = {
                        id: json.result.medicine.id,
                        title: json.result.medicine.name,
                    }

                    vm.$emit('change', createdModel)
                    vm.$nextTick(function(){
                        vm.clearSearch()
                    })
                })

            },
            debounceGetItems: debounce(function(){
                this.getItems()
            }, 300),
            async getItems(){

                var vm = this

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                vm.loading = true
                const response = await ApiUtils.makeGet(`providers/${vm.currentProvider.id}/medicines`, {
                    term: vm.search
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error consultando diagnósticos')
                    return
                }

                const json = await response.json()
                vm.medicines = json.result.medicines.data

               vm.$nextTick(function(){
                   if(vm.value){
                       vm.model = vm.value
                   }
               })

            }
        },
        computed: {
            ...mapState(['currentProvider']),
            shouldCreate(){
                return this.search && this.medicines.length === 0 && (!this.model || typeof this.model === 'string') && !this.loading
            },
            items () {
                return this.medicines.map(medicine => {
                    return {
                        id: medicine.id,
                        title: medicine.name,
                    }
                })
            }
        },
        watch: {
            search (val) {
                var vm = this
                if(vm.model && val === vm.model.title) return
                vm.model = null
                vm.debounceGetItems()
            },
            value(val){
                this.model = val
            },
            model(val){
                const vm = this
                const newModel = typeof val === 'string' ? null : val
                vm.$emit('change', newModel)
                if(val){
                  vm.$nextTick(() => {
                    vm.clearSearch()
                  })
                }
            }
        }
    }
</script>
